// extracted by mini-css-extract-plugin
export default {"uploader":"DndFileUploader_uploader__f3l3W","button":"DndFileUploader_button__UjbY6","text":"DndFileUploader_text__1xvUy"};